import { FieldError, FormState } from "react-hook-form";

import { ChexNestedFormValue } from "checkout-query-client/types/chex-form-fields";

export const mapFormErrorsToDatadog = (
  formState: FormState<ChexNestedFormValue>,
  formId: string
) => {
  const formErrors = formState.errors?.[formId] || {};
  return Object.entries(formErrors).reduce(
    (acc, [key, value]) => {
      acc[key] = (value as FieldError)?.type ?? "";
      return acc;
    },
    {} as Record<string, string>
  );
};
